import { IFailedTakeAction, ISystem,IPretrip} from "Model/ServerResponse";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  DeleteApprovals,
  PostDeleteApprovals,
  reCalculateSelectedApproval,
  SelectedApprovalSelector,
  setIsTabletView,
  setSelectedApproval,
} from "Store/PreTrip/PreTripSlice";
import { ListDetailsView } from "../../ListDetailsView/ListDetailsView";
import { PreTripActions } from "../../PreTrip/PreTripActions/PreTripActions";
import { TakeActionFailedModal } from "../../Modals/TakeActionFailedModal/TakeActionFailedModal";
import { useAppDispatch } from "Store/store";
import { PreTripListView } from "../../PreTrip/PreTripListView/PreTripListView";
import { PreTripDetailsCard } from "../../PreTrip/PreTripDetailsCard/PreTripDetailsCard";


export interface IPreTripPageProp {
}

export function PreTripPage(props: IPreTripPageProp){
  let appDispatch = useAppDispatch();

  let selectedApproval = useSelector(SelectedApprovalSelector);

  let [takeActionFailedModalOpen, setTakeActionFailedModalOpen] =
    useState<boolean>(false);
  let [failedTakeActions, setFailedTakeActions] = useState<IFailedTakeAction[]>(
    []
  );


  return (
    <div>
      {takeActionFailedModalOpen && (
        <TakeActionFailedModal
          open={takeActionFailedModalOpen}
          failedActions={failedTakeActions}
          onOk={(e: any) => setTakeActionFailedModalOpen(false)}
        />
      )}
      <ListDetailsView
        selectedApproval={selectedApproval}
        onBackClick={handleBackClick}
        onWindowSizeChange={handleWindowSizeChange}
        listView={listUI}
        detailsView={detailsUI}
      />
    </div>
  );

  function listUI() {
    return (
      <>
        <PreTripListView getActionsUI={actionsUI} />
      </>
    );
  }

  function detailsUI(){
    return (
      <>
        <PreTripDetailsCard getActionsUI={actionsUI} />
      </>
    );
  }

  function actionsUI(_isMulti: boolean, _approvals: IPretrip[]) {
    return (
      <>
        <PreTripActions
          isMulti={_isMulti}
          count={_approvals.length}
          onApprove={handleOnApprove}
          onReject={handleOnReject}
        />
      </>
    );
  }

  function handleBackClick(e: any) {
    appDispatch(setSelectedApproval(null));
  }

  function handleWindowSizeChange(e: any, isTabletView: boolean) {
    appDispatch(setIsTabletView(isTabletView));
    appDispatch(reCalculateSelectedApproval());
  }

  function handleOnApprove(e: any, isMulti: boolean, comment: string) {
    takeAction(true, isMulti, comment);
  }

  function handleOnReject(e: any, isMulti: boolean, comment: string) {
    takeAction(false, isMulti, comment);
  }

  async function takeAction(
    isApprove: boolean,
    isMulti: boolean,
    comment: string
  ): Promise<void> {
    let result = (
      await appDispatch(
        PostDeleteApprovals({
          isApprove: isApprove,
          isMulti: isMulti,
          comment: comment,
          getRequestBody: getTakeActionRequestBody,
        })
      )
    ).payload as {
      passedApprovals: IPretrip[];
      failedTakeActions: IFailedTakeAction[];
    };
    if (result.failedTakeActions.length > 0) {
      //Some approvals failed
      setTakeActionFailedModalOpen(true);
      setFailedTakeActions(result.failedTakeActions);
    }

    //Remove cards & subtract count for passed
    appDispatch(DeleteApprovals(result.passedApprovals));
  }

  function getTakeActionRequestBody(_approval: ISystem, _comment: string):any  {
    let _pretrip = _approval as IPretrip;
    let arr:any = [];
    for (let item of _pretrip.approverTypes) {
      arr.push({
        approvalId: _pretrip.id?.toString(),
        comment: _comment,
        extra: {
          approverTypeId: item?.toString(),
        },
      });
    }
    return arr;

  }
}
